// Per-language greeting used by onboarding copy ("Hallo, Alex —" etc.) and
// the Telegram link card's expected-reply hint. Kept as a single source of
// truth so adding a language here is one edit.
//
// Codes match `src/lang/registry.py`. Keep in sync when adding a language.

export const GREETING_BY_LANG: Record<string, string> = {
  de: "Hallo",
  es: "Hola",
  fr: "Bonjour",
  it: "Ciao",
  pt: "Olá",
  nl: "Hallo",
  ru: "Привет",
  ja: "こんにちは",
  zh: "你好",
  ko: "안녕하세요",
  ar: "مرحبا",
};

export function greetingFor(langCode: string | null | undefined): string {
  if (!langCode) return "Hello";
  return GREETING_BY_LANG[langCode] ?? "Hello";
}
